import {useWarrantyId} from "./stateHooks";
import {useFragment} from "@apollo/client";
import {contentService} from "../api/contentService";
import {useMemo} from "react";

const fragmentName = 'ResourceFragment';
const typename = 'Resource';

export const useWarrantyModal = () => {
    const id = useWarrantyId();
    const {data} = useFragment({
        fragment: contentService.fragments.resource,
        from: {__typename: typename, id},
        fragmentName
    });

    const type = useMemo(() => data && data.type, [data]);

    return {
        isFurniture: !!(type == 1 && id),
        isDigital: !!(type == 2 && id)
    }
}